import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect } from "react";
import { Banner, Card, PageHeader, Spinner } from "@magarac/ui";
import { GuideMarkdown } from "../../../components/help/GuideMarkdown";
import { authClient } from "../../../lib/auth-client";
import { messageFor } from "../../../lib/errors";
import { trackHelp, useWhatsNew, whatsNewSeenKey, writeSeen } from "../../../lib/help";

export const Route = createFileRoute("/_app/help/whats-new")({
  component: WhatsNewPage,
});

/** LC-6: what changed, newest first, each with the guides that explain it. */
function WhatsNewPage() {
  const q = useWhatsNew();
  const session = authClient.useSession();
  const latest = q.data?.entries[0]?.id;
  const userId = session.data?.user.id;
  useEffect(() => {
    if (!latest) return;
    writeSeen(whatsNewSeenKey(userId), latest);
    trackHelp({ kind: "whats_new" });
  }, [latest, userId]);

  return (
    <div className="mx-auto max-w-2xl">
      <nav className="mb-4 text-sm" aria-label="Breadcrumb">
        <Link to="/help" className="text-brand-700 underline">
          Help
        </Link>
      </nav>
      <PageHeader title="What's new" />
      {q.isPending ? (
        <Spinner />
      ) : q.error ? (
        <Banner tone="danger">{messageFor(q.error)}</Banner>
      ) : (
        q.data.entries.map((e) => (
          <Card key={e.id} className="mb-4">
            <p className="text-sm text-muted">
              {new Date(`${e.date}T12:00:00Z`).toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
                timeZone: "UTC",
              })}
            </p>
            <h2 className="mb-2 text-lg font-semibold">{e.title}</h2>
            <GuideMarkdown body={e.body} />
            {e.guides.length ? (
              <p className="text-sm">
                How to:{" "}
                {e.guides.map((g, i) => (
                  <span key={g.id}>
                    {i > 0 ? ", " : ""}
                    <Link to="/help/$id" params={{ id: g.id }} className="text-brand-700 underline">
                      {g.title}
                    </Link>
                  </span>
                ))}
              </p>
            ) : null}
          </Card>
        ))
      )}
    </div>
  );
}
